
export default [
    {date: "12/11",description: "Robótica educacional no ensino de Física",place: "-",speaker: "Robótica educacional no ensino de Física",time: "-",},
]
